import {
  normalizeIndustryTicker,
  persistIndustryDatasetState,
  INDUSTRY_DATASET_IDS,
  INDUSTRY_DATASET_LAYER_IDS,
} from '../../configs/industryDatasetState';

export const FILING_CHANGES_DEPTHS = {
  CATEGORY: INDUSTRY_DATASET_LAYER_IDS.CATEGORY,
  VENDOR: INDUSTRY_DATASET_LAYER_IDS.VENDOR,
  COMPANY: INDUSTRY_DATASET_LAYER_IDS.COMPANY,
};

export const FILING_CHANGES_VIEWS = {
  EVENTS: 'events',
  DEFINITIONS: 'definitions',
};

export const DEFAULT_FILING_CHANGES_NAV = {
  sectionId: FILING_CHANGES_DEPTHS.VENDOR,
  viewId: FILING_CHANGES_VIEWS.EVENTS,
};

export const FILING_CHANGES_DEPTH_ORDER = [
  FILING_CHANGES_DEPTHS.VENDOR,
  FILING_CHANGES_DEPTHS.COMPANY,
];

export const buildFilingChangesPath = ({
  sectionId = DEFAULT_FILING_CHANGES_NAV.sectionId,
  viewId = DEFAULT_FILING_CHANGES_NAV.viewId,
  ticker,
} = {}) => {
  const normalizedSectionId = sectionId === FILING_CHANGES_DEPTHS.CATEGORY
    ? FILING_CHANGES_DEPTHS.VENDOR
    : sectionId;
  const path = `/filingchanges/${normalizedSectionId}/${viewId}`;
  const normalizedTicker = normalizeIndustryTicker(ticker);
  if (normalizedSectionId !== FILING_CHANGES_DEPTHS.COMPANY || !normalizedTicker) return path;

  const params = new URLSearchParams();
  params.set('ticker', normalizedTicker);
  return `${path}?${params.toString()}`;
};

export const persistFilingChangesSelection = ({
  sectionId,
  viewId = FILING_CHANGES_VIEWS.EVENTS,
  category,
  ticker,
} = {}) => persistIndustryDatasetState({
  datasetId: INDUSTRY_DATASET_IDS.FILING_CHANGES,
  layerId: sectionId,
  viewId,
  filters: {
    ...(category ? { category } : {}),
    ...(ticker ? { ticker } : {}),
  },
});
